// extracted by mini-css-extract-plugin
export default {"scoreBar":"aIFnbG7WGyvVafq3FI5w","svgContainer":"RFOKPZWVoFF90w1O4n6F","blank":"XygdGLhr5zJczffFjPt6","fill":"D2trZUgo4O4v6h_9Znlt","halfScoreFilling":"wmGK6gYm4ujfjSJ6Dsul"};